<div
    class="data-container"
    #target
    [ngStyle]="{
        'max-height':
            extraParams && extraParams.rowsHeight
                ? 35 * extraParams.rowsHeight + 'px'
                : 'auto'
    }"
    [ngClass]="{ scrollable: extraParams && extraParams.disableFooter }"
>
    <div class="flex-col mt-data-table">
        <div *ngFor="let row of tableData" class="flex-row table-row">
            <div
                class="col overflow normal-thickness"
                *ngFor="let col of row"
                [ngClass]="{
                    'display-none': col.isExcludeColumn,
                    'clickable-column': col.clickConfig?.hasCursorPointer,
                    'bold-hover': col.clickConfig?.hasBoldHover,
                    'background-row': col.clickConfig?.isRow,
                    hoverable: col.rowHover,
                    'thin-thickness':
                        extraParams?.rowThickness === rowThicknessEnum.Thin
                }"
                [ngStyle]="{
                    'flex-grow': col.customLargeColumnConfig?.isLargeColumn
                        ? col.customLargeColumnConfig?.flexGrow
                        : col.isLargeColumn
                        ? '3'
                        : '1',
                    padding: col.customLargeColumnConfig?.customPadding
                        ? col.customLargeColumnConfig?.customPadding
                        : null
                }"
                [title]="
                    col.buttonConfig || col.status || col.deactivateTitle
                        ? ''
                        : col.value
                "
                data-toggle="tooltip"
                placement="top"
                [ngbTooltip]="
                    col.tooltipDynamicConfig?.tooltip
                        ? col.tooltipDynamicConfig.tooltip
                        : col.isActiveTooltip
                        ? col.tooltipColumn
                            ? col.tooltipColumn.tooltipText
                            : col.value
                        : null
                "
                tooltipClass="custom-tooltip"
                (click)="sendRowAndCellInfo(col.clickConfig, row, col)"
            >
                <!-- IF IT HAS A CONFIG TO TEXT COLOR -->
                <ng-container
                    *ngIf="col.textColorConfig; else noTextColorConfig"
                >
                    <span
                        [ngStyle]="{
                            color: col.textColorConfig.color,
                            'font-weight': col.textColorConfig.isBold
                                ? 'bold'
                                : '400'
                        }"
                    >
                        {{ col.value }}
                    </span>
                </ng-container>

                <ng-template #noTextColorConfig>
                    <!-- IF IT HASN'T CONFIG TO IMAGE OR COLOR -->
                    <ng-container
                        *ngIf="
                            !col.imageConfig &&
                            !col.colorConfig &&
                            !col.buttonConfig &&
                            !col.extraData &&
                            !col.status &&
                            !col.isActive &&
                            !col.badge
                        "
                    >
                        {{ col.value }}
                    </ng-container>

                    <!-- IF IT HAS A CONFIG BADGED  -->
                    <ng-container *ngIf="col.badge">
                        <ng-container *ngFor="let b of col.badge.badgeList">
                            <span
                                class="{{ b.class }}"
                                [ngStyle]="{
                                    'background-color': b.backgroundColor,
                                    color: b.color,
                                    width: b.width ? b.width : '90px',
                                    height: b.height ? b.height : '20px',
                                    'line-height': 'inherit',
                                    border: b.border,
                                    'font-size': b.fontSize,
                                    'font-weight': b.fontWeight
                                }"
                                *ngIf="col.value === b.badgeName"
                                >{{ col.value.split("/")[0] }}</span
                            >
                        </ng-container>
                    </ng-container>

                    <!-- IF IT HAS ATTACHED FILE -->
                    <ng-container *ngIf="col.extraData">
                        <span class="attached">{{ col.value }}</span>
                        <img
                            appImageSelector
                            alt="mt-image"
                            imageType="icon"
                            imageKey="attached"
                        />
                    </ng-container>

                    <!-- IF IT HAS CONFIG TO IMAGE -->
                    <ng-container
                        *ngIf="
                            col.imageConfig &&
                            col.value !== col.imageConfig.excludeValue &&
                            !col.imageConfig.isIconList
                        "
                    >
                        <img
                            appImageSelector
                            alt="mt-image"
                            [imageType]="col.imageConfig.imageType"
                            [title]="
                                (col.imageConfig.title
                                    ? col.imageConfig.title
                                    : col.value
                                ) | lang
                            "
                            [imageKey]="col.imageConfig.imageName"
                            width="80"
                            [ngStyle]="{
                                width: col.imageConfig?.imageWidth
                                    ? col.imageConfig?.imageWidth
                                    : '100%',
                                height: col.imageConfig?.imageHeight
                                    ? col.imageConfig?.imageHeight
                                    : '100%',
                                margin: col.imageConfig?.margin
                                    ? col.imageConfig?.margin
                                    : '-8px 0px 0px -20px'
                            }"
                        />
                    </ng-container>

                    <ng-container
                        *ngIf="col.imageConfig && col.imageConfig.isIconList"
                    >
                        <ng-container
                            *ngFor="let i of col.imageConfig.iconList"
                        >
                            {{ col.imageConfig.imageType }}
                            <img
                                *ngIf="
                                    i.iconName.toLowerCase() ==
                                    col.value.toLowerCase()
                                "
                                appImageSelector
                                alt="mt-image"
                                [imageType]="col.imageConfig.imageType"
                                [title]="
                                    (col.imageConfig.title
                                        ? col.imageConfig.title
                                        : col.value
                                    ) | lang
                                "
                                [imageKey]="i.imageName"
                                width="80"
                                [ngStyle]="{
                                    width: i?.imageWidth
                                        ? i?.imageWidth
                                        : '100%',
                                    height: i?.imageHeight
                                        ? i?.imageHeight
                                        : '100%',
                                    margin: i?.margin
                                        ? i?.margin
                                        : '-8px 0px 0px -20px'
                                }"
                            />
                        </ng-container>
                    </ng-container>
                    <!-- IF IT HAS CONFIG TO COLOR -->
                    <ng-container *ngIf="col.colorConfig">
                        <span
                            [ngStyle]="{
                                color: col.colorConfig.color,
                                'font-weight': col.colorConfig.isBold
                                    ? 'bold'
                                    : '400'
                            }"
                            >{{ col.value }}</span
                        >
                    </ng-container>

                    <ng-container *ngIf="col.isActive">
                        <div class="user-status">
                            <img
                                alt="circle-green"
                                *ngIf="col.value === 1"
                                appImageSelector
                                imageType="icon"
                                imageKey="circle-green"
                                [title]="'Usuario Activo'"
                            />
                            <img
                                alt="lock-red"
                                *ngIf="col.value === 0"
                                appImageSelector
                                imageType="icon"
                                imageKey="lock-red"
                                [title]="'Usuario Bloqueado'"
                            />
                        </div>
                    </ng-container>

                    <ng-container *ngIf="col.buttonConfig">
                        <ng-container
                            *ngFor="let button of col.buttonConfig.buttons"
                        >
                            <button
                                *ngIf="button.image !== 'download'"
                                class="btn btn-{{ button.color }}"
                                (click)="button.callback(col.value)"
                            >
                                <span *ngIf="button.textInside">{{
                                    button.textInside
                                }}</span>

                                <img
                                    alt="button-image"
                                    *ngIf="button.image"
                                    appImageSelector
                                    [imageType]="button.image.imageType"
                                    [imageKey]="button.image.imageKey"
                                />
                            </button>

                            <button
                                *ngIf="button.image === 'download'"
                                class="btn"
                                [title]="button.getFileName(col.value)"
                                [ngClass]="
                                    col.value !== '-'
                                        ? 'btn-orange'
                                        : 'btn-gray'
                                "
                                [disabled]="col.value === '-'"
                                (click)="button.callback(col.value)"
                            >
                                <span *ngIf="button.textInside">{{
                                    button.textInside
                                }}</span>

                                <img
                                    alt="download-active"
                                    *ngIf="col.value !== '-'"
                                    appImageSelector
                                    imageType="icon"
                                    imageKey="download-active"
                                />
                                <img
                                    alt="download-inactive"
                                    *ngIf="col.value === '-'"
                                    appImageSelector
                                    imageType="icon"
                                    imageKey="download-inactive"
                                />
                            </button>
                        </ng-container>
                    </ng-container>

                    <ng-container *ngIf="col.status">
                        <app-switch-button
                            leftLabel="on"
                            rightLabel="off"
                            [config]="col?.status?.config"
                            [switchStatus]="!col?.value"
                            [preventChange]="true"
                            *ngIf="col?.status?.config"
                        ></app-switch-button>
                        <span
                            class="dot"
                            *ngIf="!col?.status?.config"
                            [ngClass]="{ on: col.value, off: !col.value }"
                        ></span>
                    </ng-container>
                </ng-template>
            </div>
        </div>
    </div>
</div>
